import React from 'react';
import PropTypes from 'prop-types';

const LockerWithArrow = ({ outlineColor, s: { width, height } }) => (
  <svg width={width} height={height} viewBox="0 0 80 80" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.134 15.597h-15.49c-1.132 0-2.05.918-2.05 2.052v44.702c0 1.133.918 2.052 2.05 2.052h15.49V15.596Zm1.595 0h15.718c1.132 0 2.05.918 2.05 2.052v17.334h1.594V17.649A3.647 3.647 0 0 0 51.446 14H18.645A3.647 3.647 0 0 0 15 17.65v44.7A3.647 3.647 0 0 0 18.645 66h32.802a3.647 3.647 0 0 0 3.644-3.65V44.106h-1.594v18.246a2.051 2.051 0 0 1-2.05 2.052H35.728v-23.95l26.552-.103-3.698 3.731a.799.799 0 0 0 1.132 1.125l5.054-5.1a.8.8 0 0 0-.005-1.129l-5.093-5.06a.797.797 0 1 0-1.123 1.133l3.727 3.703-26.546.104v-23.26Zm3.645 11.06a.798.798 0 1 0-1.595 0v4.626a.798.798 0 1 0 1.595 0v-4.625Zm-16.287 30.22a.798.798 0 0 0 0 1.597h4.567a.798.798 0 0 0 0-1.597h-4.567Zm-.798 4.448c0-.441.357-.799.798-.799h4.567a.798.798 0 0 1 0 1.597h-4.567a.798.798 0 0 1-.798-.798Zm9.795-23.72a.798.798 0 1 0-1.594 0v4.625a.798.798 0 1 0 1.594 0v-4.625Zm6.492 12.886c.44 0 .798.358.798.798v4.625a.798.798 0 1 1-1.595 0V51.29c0-.44.357-.798.797-.798Z"
      fill={outlineColor}
    />
  </svg>
);

LockerWithArrow.defaultProps = {
  outlineColor: '#000000',
  s: {},
};

LockerWithArrow.propTypes = {
  s: PropTypes.object,
  outlineColor: PropTypes.string,
};

export default LockerWithArrow;
